import type { CrmMessages } from "./englishCrmMessages";

export const spanishCrmMessages = {
  resources: {
    companies: {
      name: "Empresa |||| Empresas",
      forcedCaseName: "Empresa",
      fields: {
        name: "Nombre de la empresa",
        website: "Web",
        linkedin_url: "URL de LinkedIn",
        phone_number: "Teléfono",
        created_at: "Creada el",
        nb_contacts: "Número de contactos",
        revenue: "Facturación",
        sector: "Sector",
        size: "Tamaño",
        tax_identifier: "NIF/CIF",
        address: "Dirección",
        city: "Ciudad",
        zipcode: "Código postal",
        state_abbr: "Provincia",
        country: "País",
        description: "Descripción",
        context_links: "Enlaces de contexto",
        sales_id: "Responsable",
      },
      empty: {
        description: "Parece que tu lista de empresas está vacía.",
        title: "No hay empresas",
      },
      import: {
        title: "Importar empresas",
      },
      field_categories: {
        contact: "Contacto",
        additional_info: "Información adicional",
        address: "Dirección",
        context: "Contexto",
      },
      page: { create: "Nueva empresa" },
      action: {
        create: "Nueva empresa",
        edit: "Editar empresa",
        new: "Nueva empresa",
        show: "Ver empresa",
      },
      added_on: "Añadida el %{date}",
      followed_by: "Seguida por %{name}",
      followed_by_you: "Seguida por ti",
      no_contacts: "Sin contactos",
      nb_contacts: "%{smart_count} contacto |||| %{smart_count} contactos",
      nb_deals: "%{smart_count} oportunidad |||| %{smart_count} oportunidades",
      related: {
        contacts: "Contactos",
        deals: "Oportunidades",
        tasks: "Tareas",
        empty_contacts: "Esta empresa aún no tiene contactos",
        empty_deals: "Aún no hay oportunidades con esta empresa",
        empty_tasks: "Sus contactos no tienen tareas pendientes",
        add_contact: "Añadir contacto",
        add_deal: "Añadir oportunidad",
        show_all: "Ver todos (%{count})",
      },
      sizes: {
        one_employee: "1 empleado",
        two_to_nine_employees: "2-9 empleados",
        ten_to_forty_nine_employees: "10-49 empleados",
        fifty_to_two_hundred_forty_nine_employees: "50-249 empleados",
        two_hundred_fifty_or_more_employees: "250 o más empleados",
      },
      autocomplete: {
        create_error: "Se ha producido un error al crear la empresa",
        create_item: "Crear %{item}",
        create_label: "Empieza a escribir para crear una empresa",
      },
    },
    contacts: {
      name: "Contacto |||| Contactos",
      forcedCaseName: "Contacto",
      field_categories: {
        background_info: "Contexto",
        identity: "Identidad",
        misc: "Otros",
        personal_info: "Datos personales",
        position: "Cargo",
      },
      fields: {
        first_name: "Nombre",
        last_name: "Apellidos",
        last_seen: "Último contacto",
        title: "Cargo",
        company_id: "Empresa",
        email_jsonb: "Emails",
        email: "Email",
        phone_jsonb: "Teléfonos",
        phone_number: "Teléfono",
        linkedin_url: "URL de LinkedIn",
        background: "Contexto (biografía, cómo os conocisteis, etc.)",
        has_newsletter: "Recibe la newsletter",
        sales_id: "Responsable",
      },
      page: { create: "Nuevo contacto" },
      action: {
        add: "Añadir contacto",
        add_first: "Añade tu primer contacto",
        create: "Nuevo contacto",
        edit: "Editar contacto",
        export_vcard: "Exportar a vCard",
        new: "Nuevo contacto",
        show: "Ver contacto",
      },
      autocomplete: {
        create_item: "Crear %{item}",
        create_label: "Empieza a escribir para crear un contacto",
      },
      background: {
        last_activity_on: "Última actividad el %{date}",
        added_on: "Añadido el %{date}",
        followed_by: "Seguido por %{name}",
        followed_by_you: "Seguido por ti",
        status_none: "Ninguno",
      },
      position_at: "%{title} en",
      position_at_company: "%{title} en %{company}",
      empty: {
        description: "Parece que tu lista de contactos está vacía.",
        title: "No hay contactos",
      },
      import: {
        title: "Importar contactos",
      },
      inputs: {
        genders: {
          male: "Él",
          female: "Ella",
          nonbinary: "Elle",
        },
        personal_info_types: {
          work: "Trabajo",
          home: "Casa",
          other: "Otro",
        },
      },
      list: {
        error_loading: "Error al cargar los contactos",
        select_contact: "Seleccionar a %{name}",
      },
      bulk_tag: {
        action: "Etiquetar",
        back: "Volver a las etiquetas",
        create_description:
          "Crea una etiqueta nueva y aplícala a los contactos seleccionados.",
        description:
          "Elige una etiqueta o crea una nueva para los contactos seleccionados.",
        empty:
          "Todavía no hay etiquetas. Crea una para etiquetar los contactos seleccionados.",
        error: "No se ha podido añadir la etiqueta a los contactos",
        removed:
          "Etiqueta quitada de %{smart_count} contacto |||| Etiqueta quitada de %{smart_count} contactos",
        success:
          "Etiqueta añadida a %{smart_count} contacto |||| Etiqueta añadida a %{smart_count} contactos",
        title: "Añadir etiqueta a los contactos",
      },
      merge: {
        action: "Fusionar con otro contacto",
        confirm: "Fusionar contactos",
        current_contact: "Contacto actual (se eliminará)",
        description: "Fusiona este contacto con otro.",
        error: "No se han podido fusionar los contactos",
        merging: "Fusionando...",
        no_additional_data: "No hay más datos que fusionar",
        select_target: "Elige el contacto con el que fusionar",
        success: "Contactos fusionados",
        target_contact: "Contacto destino (se conservará)",
        title: "Fusionar contacto",
        warning_description:
          "Todos los datos pasarán al segundo contacto. Esta acción no se puede deshacer.",
        warning_title: "Atención: operación irreversible",
        what_will_be_merged: "Qué se fusionará:",
        will_reassign_notes:
          "Se reasignará %{smart_count} nota |||| Se reasignarán %{smart_count} notas",
        will_reassign_tasks:
          "Se reasignará %{smart_count} tarea |||| Se reasignarán %{smart_count} tareas",
        will_update_deals:
          "Se actualizará %{smart_count} oportunidad |||| Se actualizarán %{smart_count} oportunidades",
        will_add_emails:
          "Se añadirá %{smart_count} email |||| Se añadirán %{smart_count} emails",
        will_add_phones:
          "Se añadirá %{smart_count} teléfono |||| Se añadirán %{smart_count} teléfonos",
      },
      filters: {
        before_last_month: "Antes del mes pasado",
        before_this_month: "Antes de este mes",
        before_this_week: "Antes de esta semana",
        managed_by_me: "Gestionados por mí",
        search: "Buscar nombre, empresa...",
        this_week: "Esta semana",
        today: "Hoy",
        tags: "Etiquetas",
        tasks: "Tareas",
      },
      hot: {
        empty_change_status:
          'Cambia el estado de un contacto añadiéndole una nota y pulsando en "Mostrar opciones".',
        empty_hint: 'Aquí aparecerán los contactos con estado "caliente".',
        title: "Contactos calientes",
      },
    },
    deals: {
      name: "Oportunidad |||| Oportunidades",
      fields: {
        name: "Nombre",
        description: "Descripción",
        company_id: "Empresa",
        contact_ids: "Contactos",
        categories: "Categorías",
        amount: "Importe",
        expected_closing_date: "Fecha prevista de cierre",
        stage: "Fase",
      },
      page: { create: "Nueva oportunidad" },
      action: {
        back_to_deal: "Volver a la oportunidad",
        create: "Nueva oportunidad",
        new: "Nueva oportunidad",
      },
      field_categories: {
        misc: "Otros",
      },
      filters: {
        only_mine: "Solo las que gestiono yo",
      },
      archived: {
        action: "Archivar",
        error: "Error: no se ha podido archivar la oportunidad",
        list_title: "Oportunidades archivadas",
        success: "Oportunidad archivada",
        title: "Oportunidad archivada",
        view: "Ver oportunidades archivadas",
      },
      inputs: {
        linked_to: "Vinculada a",
      },
      unarchived: {
        action: "Devolver al tablero",
        error: "Error: no se ha podido desarchivar la oportunidad",
        success: "Oportunidad desarchivada",
      },
      updated: "Oportunidad actualizada",
      empty: {
        before_create: "antes de crear una oportunidad.",
        description: "Parece que tu lista de oportunidades está vacía.",
        title: "No hay oportunidades",
      },
      import: {
        title: "Importar oportunidades",
      },
      invalid_date: "Fecha no válida",
      mobile: {
        new_short: "Nueva",
        search: "Buscar oportunidades",
        clear_search: "Quitar búsqueda",
        filters: "Filtros",
        filters_active:
          "%{smart_count} filtro activo |||| %{smart_count} filtros activos",
        all: "Todas",
        only_mine: "Solo mis oportunidades",
        visible_stage: "Etapa visible",
        sort_by: "Ordenar por",
        sort_amount: "Importe",
        sort_closing: "Fecha de cierre",
        sort_recent: "Recientes",
        clear: "Limpiar",
        apply: "Aplicar",
        closing: "Cierre %{date}",
        no_match: "Ninguna oportunidad coincide con estos filtros",
        stage_updated: "Etapa actualizada",
        stage_update_error: "No se ha podido actualizar la etapa",
        more_actions: "Más acciones",
        company_contacts: "Empresa y contactos",
        details: "Detalles",
        notes: "Notas",
        show_more: "Ver más",
        show_less: "Ver menos",
        delivery: "Entrega",
      },
    },
    notes: {
      name: "Nota |||| Notas",
      forcedCaseName: "Nota",
      fields: {
        status: "Estado",
        date: "Fecha",
        attachments: "Adjuntos",
        contact_id: "Contacto",
        deal_id: "Oportunidad",
      },
      page: { create: "Nueva nota" },
      action: {
        add: "Añadir nota",
        add_first: "Añade tu primera nota",
        delete: "Eliminar nota",
        edit: "Editar nota",
        update: "Actualizar nota",
        add_this: "Añadir esta nota",
      },
      sheet: {
        create: "Nueva nota",
        create_for: "Nueva nota para %{name}",
        edit: "Editar nota",
        edit_for: "Editar nota de %{name}",
      },
      deleted: "Nota eliminada",
      empty: "Todavía no hay notas",
      author_added: "%{name} ha añadido una nota",
      you_added: "Has añadido una nota",
      me: "Yo",
      list: {
        error_loading: "Error al cargar las notas",
      },
      note_for_contact: "Nota para %{name}",
      stepper: {
        hint: "Ve a la ficha de un contacto y añade una nota",
      },
      added: "Nota añadida",
      inputs: {
        add_note: "Añadir una nota",
        options_hint: "(adjuntar archivos o cambiar detalles)",
        show_options: "Mostrar opciones",
      },
      actions: {
        attach_document: "Adjuntar documento",
      },
      validation: {
        note_or_attachment_required: "Hace falta una nota o un adjunto",
      },
    },
    sales: {
      name: "Usuario |||| Usuarios",
      fields: {
        first_name: "Nombre",
        last_name: "Apellidos",
        email: "Email",
        secondary_email: "Email secundario",
        secondary_emails: "Emails secundarios",
        administrator: "Administrador",
        disabled: "Desactivado",
      },
      create: {
        error: "Se ha producido un error al crear el usuario.",
        success:
          "Usuario creado. En breve recibirá un email para elegir su contraseña.",
        title: "Nuevo usuario",
      },
      edit: {
        error: "Se ha producido un error. Inténtalo de nuevo.",
        record_not_found: "Registro no encontrado",
        success: "Usuario actualizado",
        title: "Editar a %{name}",
      },
      page: { create: "Nuevo usuario" },
      action: {
        new: "Nuevo usuario",
      },
    },
    tasks: {
      name: "Tarea |||| Tareas",
      forcedCaseName: "Tarea",
      fields: {
        text: "Descripción",
        due_date: "Fecha límite",
        type: "Tipo",
        contact_id: "Contacto",
        due_short: "vence",
      },
      page: { create: "Nueva tarea" },
      action: {
        add: "Añadir tarea",
        create: "Nueva tarea",
        edit: "Editar tarea",
      },
      actions: {
        postpone_next_week: "Aplazar a la semana que viene",
        postpone_tomorrow: "Aplazar a mañana",
        title: "acciones de la tarea",
      },
      added: "Tarea añadida",
      deleted: "Tarea eliminada",
      dialog: {
        create: "Nueva tarea",
        create_for: "Nueva tarea para %{name}",
      },
      sheet: {
        edit: "Editar tarea",
        edit_for: "Editar tarea de %{name}",
      },
      empty: "Todavía no hay tareas",
      empty_list_hint: "Aquí aparecerán las tareas de tus contactos.",
      filters: {
        later: "Más adelante",
        overdue: "Vencidas",
        this_week: "Esta semana",
        today: "Hoy",
        tomorrow: "Mañana",
        with_pending: "Con tareas pendientes",
      },
      regarding_contact: "(Sobre: %{name})",
      updated: "Tarea actualizada",
      // ---- internal tasks ----
      kind: {
        nav: "Equipo y clientes",
        list_title: "Equipo y clientes",
        label: "Tipo de tarea",
        internal: "Interna",
        client: "Proyecto / Cliente",
        client_short: "Cliente",
        all: "Todas",
        filter_label: "Filtrar tareas por tipo",
        assignee: "Asignada a",
        internal_hint: "Para organizarnos en el equipo, sin contacto.",
        client_hint: "Vinculada a un contacto de un proyecto o cliente.",
        contact_required:
          "Elige un contacto para una tarea de proyecto o cliente",
        assignee_required: "Elige a quién se asigna la tarea",
        assigned_to: "Para %{name}",
        empty_internal: "No hay tareas internas pendientes.",
        empty_client: "No hay tareas de clientes pendientes.",
      },
      // ---- end internal tasks ----
    },
    tags: {
      name: "Etiqueta |||| Etiquetas",
      action: {
        add: "Añadir etiqueta",
        create: "Nueva etiqueta",
      },
      dialog: {
        color: "Color",
        create_title: "Nueva etiqueta",
        edit_title: "Editar etiqueta",
        name_label: "Nombre de la etiqueta",
        name_placeholder: "Escribe el nombre de la etiqueta",
      },
      empty: "Todavía no hay etiquetas.",
    },
    // ---- create-page titles of the hub resources (ra-core reads
    // resources.<name>.page.create); their other keys live in fretum/i18n.ts ----
    team_tasks: { page: { create: "Nueva tarea" } },
    events: { page: { create: "Nuevo evento" } },
    delivery_templates: { page: { create: "Nueva plantilla de entrega" } },
    time_entries: { page: { create: "Nuevo registro de horas" } },
    styles: { page: { create: "Nuevo estilo" } },
    wiki_pages: { page: { create: "Nueva página" } },
    subscriptions: { page: { create: "Nuevo coste" } },
    quotes: { page: { create: "Nuevo presupuesto" } },
    invoices: { page: { create: "Nueva factura" } },
    // ---- end hub create-page titles ----
  },
  crm: {
    action: {
      reset_password: "Restablecer contraseña",
    },
    auth: {
      first_name: "Nombre",
      last_name: "Apellidos",
      confirm_password: "Confirmar contraseña",
      confirmation_required:
        "Abre el enlace que te acabamos de enviar por email para confirmar tu cuenta.",
      recovery_email_sent:
        "Si tienes cuenta, en breve recibirás un email para recuperar la contraseña.",
      sign_in_failed: "No se ha podido iniciar sesión.",
      sign_in_google_workspace: "Iniciar sesión con Google Workspace",
      link_error_details:
        "Los enlaces de invitación y de cambio de contraseña solo se pueden usar una vez y caducan al cabo de un tiempo. Pide a un administrador una nueva invitación o solicita un enlace nuevo en «¿Has olvidado la contraseña?».",
      link_expired_title: "Este enlace ha caducado",
      link_invalid_title: "Este enlace no es válido",
      request_new_link: "Pedir un enlace nuevo",
      signup: {
        create_account: "Crear cuenta",
        create_first_user:
          "Crea la primera cuenta de usuario para terminar la configuración.",
        creating: "Creando...",
        initial_user_created: "Usuario inicial creado",
      },
      welcome_title: "Bienvenido a Avante",
    },
    common: {
      account_manager: "Responsable",
      activity: "Actividad",
      added: "añadido",
      details: "Detalles",
      last_activity_with_date: "última actividad %{date}",
      load_more: "Cargar más",
      misc: "Otros",
      past: "Pasadas",
      read_more: "Leer más",
      retry: "Reintentar",
      show_less: "Mostrar menos",
      copied: "¡Copiado!",
      copy: "Copiar",
      close_notification: "Cerrar aviso",
      loading: "Cargando...",
      me: "Yo",
      task_count: "%{smart_count} tarea |||| %{smart_count} tareas",
      unnamed: "Sin nombre",
    },
    empty_state: {
      title: "Aún no hay %{name}",
      hint: "Lo que añadas aparecerá aquí.",
      filtered_title: "Sin resultados",
      filtered_hint: "No hay %{name} que coincidan con los filtros actuales.",
      clear_filters: "Quitar filtros",
      resources: {
        invoices: {
          title: "Aún no hay facturas",
          hint: "Registra tus facturas para controlar lo pendiente de cobro y lo cobrado.",
        },
        quotes: {
          title: "Aún no hay presupuestos",
          hint: "Prepara un presupuesto para un cliente y sigue su estado.",
        },
        wiki_pages: {
          title: "La wiki está vacía",
          hint: "Documenta procesos, guías y el conocimiento del equipo.",
        },
        subscriptions: {
          title: "Aún no hay costes",
          hint: "Añade suscripciones y gastos fijos para ver cuánto gastas al mes.",
        },
        time_entries: {
          title: "No hay horas registradas",
          hint: "Registra el tiempo dedicado a tareas y oportunidades.",
        },
        team_tasks: {
          title: "No hay tareas del equipo",
          hint: "Crea una tarea y asígnala a alguien del equipo.",
        },
        delivery_templates: {
          title: "No hay plantillas de entrega",
          hint: "Una plantilla crea de una vez los hitos de una oportunidad.",
        },
        styles: {
          title: "Aún no hay estilos",
          hint: "Guarda colores y tipografías para reutilizarlos en tus proyectos.",
        },
        tasks: {
          title: "No hay tareas",
          hint: "Las tareas que crees aparecerán aquí.",
        },
        sales: {
          title: "No hay usuarios",
          hint: "Invita a las personas de tu equipo.",
        },
      },
    },
    style_preview: {
      label: "Vista previa del estilo",
      button: "Botón",
    },
    splash: {
      greeting: "Hi, %{name}",
    },
    pwa: {
      update_available: "Nueva versión disponible",
      update: "Actualizar",
      later: "Ahora no",
    },
    changelog: {
      title: "Novedades",
      subtitle:
        "Lo último que ha cambiado en Avante, de lo más reciente a lo más antiguo.",
      change_number: "Cambio n.º %{number}",
      categories_label: "Categorías",
      categories: {
        new: "Nuevo",
        mobile: "Móvil",
        desktop: "Escritorio",
        fix: "Corrección",
      },
    },
    activity: {
      added_company: "%{name} ha añadido la empresa",
      you_added_company: "Has añadido la empresa",
      added_contact: "%{name} ha añadido a",
      you_added_contact: "Has añadido a",
      added_note: "%{name} ha añadido una nota sobre",
      you_added_note: "Has añadido una nota sobre",
      added_note_about_deal: "%{name} ha añadido una nota sobre la oportunidad",
      you_added_note_about_deal: "Has añadido una nota sobre la oportunidad",
      added_deal: "%{name} ha añadido la oportunidad",
      you_added_deal: "Has añadido la oportunidad",
      at_company: "en",
      to: "a",
      load_more: "Cargar más actividad",
    },
    dashboard: {
      latest_activity: "Actividad reciente",
      latest_activity_error: "Error al cargar la actividad reciente",
      stepper: {
        install: "Instalar Avante",
        progress: "%{step}/3 completados",
        whats_next: "¿Y ahora qué?",
      },
    },
    data_import: {
      button: "Importar CSV",
      complete:
        "Importación completada. %{importCount} registros importados, con %{errorCount} errores",
      csv_file: "Archivo CSV",
      error:
        "No se ha podido importar este archivo. Comprueba que es un CSV válido.",
      in_progress: "Importación en curso…",
      progress:
        "%{importCount} / %{rowCount} registros importados, con %{errorCount} errores.",
      remaining_time: "Tiempo restante estimado:",
      resource: "Recurso",
      sample_download: "Descargar CSV de ejemplo",
      sample_hint:
        "Aquí tienes un CSV de ejemplo que puedes usar como plantilla",
      start: "Empezar importación",
      stop: "Detener importación",
      stopped:
        "Importación detenida. %{importCount} registros importados, con %{errorCount} errores",
      title: "Importar datos",
    },
    header: {
      import_data: "Importar desde JSON",
    },
    search: {
      title: "Buscar",
      placeholder:
        "Buscar contactos, empresas, oportunidades, tareas y notas...",
      hint: "Escribe al menos %{min} caracteres para buscar",
      empty: "No hay resultados",
      error: "La búsqueda no está disponible ahora mismo. Inténtalo de nuevo.",
      untitled_result: "(sin título)",
      show_more: "Mostrar más",
      cancel: "Cancelar",
      clear_query: "Borrar búsqueda",
      recent: "Recientes",
      clear_recent: "Borrar",
      clear_recent_label: "Borrar búsquedas recientes",
      quick_links: "Ir a",
      searching: "Buscando…",
      empty_hint: "Prueba con otro nombre, empresa o palabra clave.",
      keys: { navigate: "navegar", open: "abrir", close: "cerrar" },
      groups: {
        contacts: "Contactos",
        companies: "Empresas",
        deals: "Oportunidades",
        tasks: "Tareas",
        contact_notes: "Notas de contactos",
        deal_notes: "Notas de oportunidades",
      },
    },
    image_editor: {
      change: "Cambiar",
      drop_hint: "Arrastra aquí un archivo o haz clic para seleccionarlo.",
      editable_content: "Contenido editable",
      title: "Subir y recortar imagen",
      update_image: "Actualizar imagen",
    },
    import: {
      action: {
        download_error_report: "Descargar el informe de errores",
        import: "Importar",
        import_another: "Importar otro archivo",
      },
      error: {
        unable: "No se ha podido importar este archivo.",
      },
      idle: {
        description_1:
          "Puedes importar usuarios, empresas, contactos, notas y tareas.",
        description_2:
          "Los datos deben estar en un archivo JSON con la misma estructura que este ejemplo:",
      },
      status: {
        all_success: "Todos los registros se han importado correctamente.",
        complete: "Importación completada.",
        failed: "Fallidos",
        imported: "Importados",
        in_progress: "Importación en curso, no salgas de esta página.",
        some_failed: "Algunos registros no se han importado.",
        table_caption: "Estado de la importación",
      },
      title: "Importar desde JSON",
    },
    settings: {
      about: "Acerca de",
      companies: {
        sectors: "Sectores",
      },
      dark_mode_logo: "Logo para modo oscuro",
      deals: {
        categories: "Categorías",
        currency: "Moneda",
        pipeline_help:
          "Elige qué fases cuentan como oportunidades en el embudo.",
        pipeline_statuses: "Fases del embudo",
        stages: "Fases",
      },
      light_mode_logo: "Logo para modo claro",
      notes: {
        statuses: "Estados",
      },
      reset_defaults: "Restablecer valores por defecto",
      save_error: "No se ha podido guardar la configuración",
      saved: "Configuración guardada",
      saving: "Guardando...",
      tasks: {
        types: "Tipos",
      },
      preferences: "Preferencias",
      title: "Ajustes",
      app_title: "Nombre de la aplicación",
      sections: {
        branding: "Marca",
      },
      validation: {
        duplicate: "%{display_name} duplicadas: %{items}",
        in_use:
          "No se pueden quitar %{display_name} que aún usan algunas oportunidades: %{items}",
        validating: "Validando…",
        entities: {
          categories: "categorías",
          stages: "fases",
        },
      },
    },
    theme: {
      dark: "Oscuro",
      label: "Tema",
      light: "Claro",
      system: "Sistema",
      current: "Tema: %{theme}",
      switch_to: "Cambiar a %{theme}",
    },
    language: "Idioma",
    mobile: {
      search_placeholder: "Buscar proyecto, tarea, evento...",
      status_in_progress: "En curso",
      status_upcoming: "Próxima",
      status_done: "Completada",
      nav_home: "Inicio",
      nav_reports: "Informes",
      nav_tasks: "Tareas",
      nav_deals: "Oportunidades",
      nav_market: "Mercado",
      nav_more: "Más",
      nav_close: "Cerrar",
      back: "Atrás",
      menu_title: "Secciones",
      create: "Crear",
      agenda: "Agenda",
      all_day: "Todo el día",
      no_events: "Nada programado",
      notifications: "Notificaciones",
      notifications_empty: "No hay actividad reciente",
      open_calendar: "Abrir la agenda",
      reports_title: "Informes",
      reports_subtitle: "Oportunidades abiertas",
      week_previous: "Semana anterior",
      week_next: "Semana siguiente",
      agenda_view: "Vista de la agenda",
      agenda_day: "Día",
      agenda_week: "Semana",
      agenda_month: "Mes",
      agenda_today: "Hoy",
      agenda_items: "%{smart_count} elemento |||| %{smart_count} elementos",
      day_previous: "Día anterior",
      day_next: "Día siguiente",
      month_previous: "Mes anterior",
      month_next: "Mes siguiente",
      deal_missing: "Esta oportunidad no está disponible",
      no_deals: "No hay oportunidades abiertas",
      account: "Cuenta y ajustes",
      account_group: "Cuenta",
      admin_group: "Administración",
      crm_settings: "Ajustes del CRM",
      team_tasks: "Tareas del equipo",
      close_settings: "Cerrar ajustes",
      close_agenda: "Cerrar la agenda",
      close_notifications: "Cerrar notificaciones",
      settings_title: "Ajustes",
      settings_back: "Volver a los ajustes",
      more: {
        title: "Más",
        label: "Módulos",
      },
      quick_actions: "Acciones rápidas",
      plus: {
        new_task: "Nueva tarea",
        new_note: "Nueva nota",
        go_to: "Ir a",
      },
      all_stages: "Todas las etapas",
      reports_pipeline: "Cartera abierta",
      reports_count:
        "%{smart_count} oportunidad |||| %{smart_count} oportunidades",
      reports_stage_filter: "Filtrar por etapa",
      reports_list_title: "Oportunidades",
      progress: "Progreso",
      delivery_progress: "Progreso de la entrega",
      stage_progress: "Progreso según la etapa",
      kanban_empty_deals: "Sin oportunidades",
      // Audit 2 navigation: quick agenda window, calendar, Más groups.
      calendar: "Calendario",
      more_groups: {
        crm: "CRM",
        hub: "Hub",
      },
      calendar_window: {
        open: "Abrir calendario",
        close: "Cerrar calendario",
      },
    },
    navigation: {
      label: "Navegación del CRM",
    },
    profile: {
      add_secondary_email: "Añadir un email",
      email_taken: "%{email} ya lo usa otro usuario",
      no_secondary_emails: "Ninguno",
      secondary_email_invalid: "%{email} no es un email válido",
      secondary_email_is_primary: "%{email} ya es tu email principal",
      secondary_email_taken: "%{email} ya lo usa otro usuario",
      too_many_secondary_emails:
        "No puedes añadir más de 10 emails secundarios",
      secondary_emails_help:
        "Otras direcciones desde las que envías emails. Déjala vacía para quitarla.",
      inbound: {
        description:
          "Puedes enviar emails a la dirección de entrada de tu servidor, por ejemplo poniéndola en el campo %{field}. Avante procesará los emails y añadirá notas a los contactos correspondientes.",
        title: "Email de entrada",
      },
      mcp: {
        title: "Servidor MCP",
        description:
          "Usa esta URL para conectar tu asistente de IA a los datos del CRM mediante el Model Context Protocol (MCP).",
        copy: "Copiar URL del MCP",
        copied: "URL del MCP copiada",
        copy_error: "No se ha podido copiar la URL del MCP",
      },
      password: {
        change: "Cambiar contraseña",
      },
      password_reset_sent:
        "Te hemos enviado un email para restablecer la contraseña",
      record_not_found: "Registro no encontrado",
      title: "Perfil",
      updated: "Perfil actualizado",
      update_error: "Se ha producido un error. Inténtalo de nuevo",
    },
    validation: {
      invalid_url: "Debe ser una URL válida",
      invalid_linkedin_url: "La URL debe ser de linkedin.com",
    },
  },
  // ---- desk (desktop redesign): one sub-object per area ----
  desk: {
    // ---- desk.shell (sidebar, sheet header) ----
    shell: {
      nav: {
        all: "Todos",
        all_f: "Todas",
        pipeline: "Pipeline",
        won: "Ganadas",
        lost: "Perdidas",
        pending: "Pendientes",
        done: "Hechas",
        agenda: "Agenda",
      },
      collapse: "Contraer barra lateral",
      expand: "Expandir barra lateral",
      search_placeholder: "Buscar contactos, empresas…",
      agenda_today:
        "Agenda: %{smart_count} elemento hoy |||| Agenda: %{smart_count} elementos hoy",
      more_actions: "Más acciones",
      refresh: "Actualizar datos",
      dark_mode: "Modo oscuro",
      settings: "Ajustes",
      account_menu: "Menú de la cuenta",
      notifications: {
        title: "Avisos",
        overdue: "Vencida",
        today: "Hoy",
        see_all: "Ver tareas",
        empty: "Nada pendiente para los próximos 7 días.",
      },
      goal: {
        title: "Cierres del mes",
        percent_won: "%{percent}% ganado",
        won_prefix: "Has ganado",
        of: "de",
        expected_suffix: "previstos este mes.",
        empty: "Ninguna oportunidad con cierre previsto este mes.",
        cta: "Ver pipeline",
      },
    },
    // ---- end desk.shell ----
    // ---- desk.home (vistas de inicio A «Hoy» / B «Pulso», escritorio y móvil) ----
    home: {
      view_label: "Vista de inicio",
      views: { today: "Hoy", pulse: "Pulso" },
      more_title: "Equipo y entregas",
      summary: {
        attention:
          "%{smart_count} cosa necesita tu atención |||| %{smart_count} cosas necesitan tu atención",
        overdue:
          "%{smart_count} está vencida |||| %{smart_count} están vencidas",
        all_clear: "todo al día",
      },
      counters: {
        label: "Resumen de hoy",
        overdue: "Vencido",
        today: "Hoy",
        no_next_step: "Sin próximo paso",
        no_next_step_short: "Sin paso",
        collect: "Por cobrar",
        items: "elemento |||| elementos",
        deals: "oportun. |||| oportun.",
        oldest:
          "la más antigua hace %{smart_count} día |||| la más antigua hace %{smart_count} días",
        overdue_none: "nada vencido",
        today_none: "nada programado",
        no_next_step_hint: "%{amount} sin tarea ni reunión",
        no_next_step_none: "todas tienen plan",
        collect_overdue: "%{amount} vencidos",
        collect_none: "nada vencido",
        parts: {
          events: "%{smart_count} evento |||| %{smart_count} eventos",
          tasks: "%{smart_count} tarea |||| %{smart_count} tareas",
          milestones: "%{smart_count} hito |||| %{smart_count} hitos",
        },
      },
      inbox: {
        title: "Necesita tu atención",
        subtitle: "ordenado por urgencia",
        empty: "Nada pendiente. Buen trabajo.",
        show_more: "Ver %{smart_count} más",
        show_less: "Ver menos",
        done_notice: "Hecho: %{title}",
        done_error: "No se pudo actualizar, inténtalo de nuevo",
        kind_internal: "tarea interna",
        kind_client: "tarea de cliente",
        team_task: "tarea de equipo",
        milestone: "hito",
        priority_high: "prioridad alta",
        priority_urgent: "urgente",
        event_kinds: {
          meeting: "reunión",
          demo: "demo",
          call: "llamada",
          internal: "interna",
          deadline: "entrega",
          other: "evento",
        },
        closing_passed: "cierre previsto el %{date} ya pasado",
        idle: "sin actividad desde hace %{smart_count} día |||| sin actividad desde hace %{smart_count} días",
        invoice_overdue:
          "vencida hace %{smart_count} día |||| vencida hace %{smart_count} días",
        invoice_due: "vence el %{date}",
        groups: {
          overdue: "Vencido",
          today: "Hoy",
          no_next_step: "Oportunidades sin próximo paso",
          collect: "Cobros",
        },
        hints: {
          oldest:
            "la más antigua hace %{smart_count} día |||| la más antigua hace %{smart_count} días",
          at_stake: "%{amount} en juego",
          pending: "%{amount} pendientes",
        },
        chip: {
          yesterday: "ayer",
          late: "hace %{smart_count} día |||| hace %{smart_count} días",
          today: "hoy",
          closing_late: "+%{smart_count} d",
          idle_days: "%{smart_count} d",
          invoice_late: "vencida %{smart_count} d",
        },
        actions: {
          done: "Hecho",
          done_label: "Marcar «%{title}» como hecha",
          next_step: "Próximo paso",
          next_step_short: "+ paso",
          next_step_label: "Planificar el próximo paso de «%{title}»",
          move_date: "Mover fecha",
          open_invoice: "Ver factura",
          open: "Abrir",
        },
      },
      agenda: {
        title: "Agenda de hoy",
        week: "Semana",
        all_day: "Todo el día",
        more_all_day: "+%{smart_count} más de todo el día",
        empty: "Nada con hora hoy",
        now: "Ahora",
        now_label: "Ahora, %{time}",
        tomorrow:
          "Mañana: %{smart_count} elemento |||| Mañana: %{smart_count} elementos",
        see_all: "Ver agenda",
        sources: {
          task: "Tarea",
          event: "Evento",
          team_task: "Tarea de equipo",
          deal_closing: "Cierre previsto",
          milestone: "Hito",
          renewal: "Renovación",
          invoice_due: "Vencimiento de factura",
        },
      },
      collect: {
        title: "Por cobrar",
        vat: "IVA incl.",
        collected_month: "+%{amount} cobrado este mes",
        overdue_badge: "%{amount} vencido",
        overdue: "Vencido",
        dueThisWeek: "Vence esta semana",
        later: "Más adelante",
        empty: "Nada pendiente de cobro",
        see_all: "Facturas",
      },
      quick: {
        title: "Acciones rápidas",
        task: "Tarea",
        note: "Nota",
        deal: "Oportun.",
        invoice: "Factura",
        contact: "Contacto",
        task_hint: "Nueva tarea",
        note_hint: "Nueva nota",
        deal_hint: "Nueva oportunidad",
        invoice_hint: "Nueva factura",
        contact_hint: "Nuevo contacto",
      },
      next: {
        empty: "Nada más con hora esta semana",
        now: "ahora",
        in_minutes: "en %{smart_count} min",
        today: "Hoy",
        tomorrow: "Mañana",
      },
      mobile: {
        next: "Siguiente",
        agenda: "Agenda",
        attention: "Necesita atención",
        see_all: "Ver todo",
        collect: "Por cobrar",
        invoices: "Facturas",
      },
      pulse: {
        title: "Pulso del negocio",
        subtitle: "en vivo desde tus datos",
        approx: "aprox.",
        kpi: {
          label: "Cifras del negocio",
          pipeline: "Pipeline abierto",
          pipeline_hint:
            "%{smart_count} oportunidad activa |||| %{smart_count} oportunidades activas",
          won: "Ganado este mes",
          won_approx:
            "Avante no guarda la fecha en que se gana una oportunidad: se cuentan las ganadas cuyo cierre previsto cae en este mes. «Cierres previstos» no es un objetivo: es la suma de las oportunidades que se espera cerrar este mes.",
          won_hint: "de %{amount} en cierres previstos",
          won_none: "ninguna oportunidad con cierre previsto este mes",
          won_ratio: "%{percent} de los cierres previstos",
          invoiced: "Facturado",
          net: "sin IVA",
          invoiced_hint:
            "%{month} · %{smart_count} factura |||| %{month} · %{smart_count} facturas",
          invoiced_trend: "Facturado en los últimos 6 meses",
          outstanding: "Pendiente de cobro",
          outstanding_overdue: "%{amount} vencido",
          outstanding_hint:
            "%{smart_count} factura emitida · IVA incl. |||| %{smart_count} facturas emitidas · IVA incl.",
        },
        revenue: {
          title: "Ingresos",
          subtitle: "facturado frente a cobrado, sin IVA",
          legend: "Series",
          invoiced: "Facturado",
          collected: "Cobrado",
          total_invoiced: "facturado en 6 meses",
          total_collected: "cobrado en 6 meses",
          empty: "Sin facturas en los últimos 6 meses",
          month_label: "%{month}: facturado %{invoiced}, cobrado %{collected}",
          month: "Mes",
        },
        funnel: {
          title: "Embudo por etapa",
          subtitle: "oportunidades abiertas",
          empty: "Sin oportunidades abiertas",
          deals: "%{smart_count} oportun. |||| %{smart_count} oportun.",
          overdue_closings:
            "Cierre previsto vencido (%{smart_count}) |||| Cierre previsto vencido (%{smart_count})",
        },
        deliveries: {
          title: "Proyectos en entrega",
          active: "%{smart_count} activo |||| %{smart_count} activos",
          see_all: "Ver oportunidades",
          empty: "Ningún proyecto en entrega",
          project: "Proyecto",
          progress: "Avance",
          status: "Estado",
          next: "Próx. hito",
          milestones: "hito %{done} de %{total}",
          today: "hoy",
        },
        hours: {
          title: "Horas · %{month}",
          billable: "%{percent} facturables",
          empty: "Sin horas registradas este mes",
          logged: "registradas este mes",
          no_deal: "Interno · sin oportunidad",
        },
        costs: {
          title: "Costes fijos",
          subtitle: "suscripciones",
          active: "%{smart_count} activa |||| %{smart_count} activas",
          empty: "Sin suscripciones activas",
          per_month: "/ mes · %{yearly} / año",
          renewals: "Próximas renovaciones",
          periods: {
            monthly: "mensual",
            yearly: "anual",
            one_off: "pago único",
          },
          see_all: "Ver costes",
        },
      },
      setting: {
        section: "Preferencias",
        title: "Vista de inicio por defecto",
        hint: "Lo que ves al abrir Avante en el ordenador. Se guarda en este navegador.",
      },
    },
    // ---- end desk.home ----
  },
  // ---- end desk ----
} satisfies CrmMessages;
